import { IRewardClaimDetailMock } from "../mock";
import { FaFileArrowUp, FaRotateRight } from "react-icons/fa6";

interface IProps {
  detail: IRewardClaimDetailMock;
}

export function RewardRequestPanel({ detail }: IProps) {
  return (
    <div className="card h-100">
      <div className="card-header">
        <div className="card-title">Resumo das Solicitações</div>
        <div className="card-category">
          Visão geral dos requisitos de cada prêmio.
        </div>
      </div>
      <div className="card-body">
        <div className="d-grid gap-3">
          {detail.requirements.map((requirement) => {
            const reward = detail.rewards.find(
              (item) => item.claimId === requirement.claimId,
            );

            return (
              <div className="border rounded p-3" key={requirement.claimId}>
                <div className="fw-bold text-dark mb-1">
                  {reward?.reward.name || `Prêmio #${requirement.claimId}`}
                </div>
                <div className="text-muted small mb-2">
                  {requirement.instructions}
                </div>
                <div className="d-flex flex-wrap gap-2">
                  {requirement.requiredFiles.map((file) => (
                    <span
                      className="badge bg-light text-muted border"
                      key={`${requirement.claimId}-${file}`}
                    >
                      {file}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {detail.files.length > 0 && (
          <div className="border rounded p-3 mt-3">
            <div className="fw-semibold mb-2">Arquivos anexados</div>
            <div className="d-grid gap-2">
              {detail.files.map((file) => (
                <div
                  className="d-flex justify-content-between gap-3 small"
                  key={file.id}
                >
                  <span>
                    <FaFileArrowUp className="me-2 text-primary" />
                    {file.name}
                  </span>
                  <span className="text-muted">{file.type}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <button
          type="button"
          className="btn btn-outline-secondary w-100 mt-3"
          title="Atualizar informações da premiação."
        >
          <FaRotateRight className="me-2" />
          Atualizar informações
        </button>
      </div>
    </div>
  );
}
